import { num, type ComponentForm } from '../component-types.js';

/**
 * `light2d` (Unity URP 2D light): global, point, spot, freeform or sprite
 * light for sprites and tilemaps (see engine/docs/systems/lighting-2d.md).
 */
const light2d: ComponentForm = {
  key: 'light2d',
  label: '2D Light',
  icon: 'light',
  order: 32,
  defaults: { kind: 'point', color: [1, 1, 1], intensity: 1, outerRadius: 5 },
  fields: [
    { key: 'kind', label: 'Type', type: { kind: 'enum', options: ['global', 'point', 'spot', 'freeform', 'sprite'] }, read: (v) => v.kind ?? 'point' },
    { key: 'color', label: 'Color', type: { kind: 'color' }, read: (v) => v.color ?? [1, 1, 1] },
    { key: 'intensity', label: 'Intensity', type: num(0.1, { min: 0 }), read: (v) => v.intensity ?? 1 },
    { key: 'blend', label: 'Blend', type: { kind: 'enum', options: ['additive', 'multiply'] }, read: (v) => v.blend ?? 'additive' },
    { key: 'innerRadius', label: 'Inner Radius', type: num(0.1, { min: 0 }), showIf: (v) => v.kind !== 'global', read: (v) => v.innerRadius ?? 0 },
    { key: 'outerRadius', label: 'Outer Radius', type: num(0.1, { min: 0 }), showIf: (v) => v.kind !== 'global', read: (v) => v.outerRadius ?? 5 },
    { key: 'falloff', label: 'Falloff', type: num(0.1, { min: 0.01 }), showIf: (v) => v.kind !== 'global', read: (v) => v.falloff ?? 1 },
    { key: 'innerAngle', label: 'Inner Angle', type: num(1, { min: 0, max: 360 }), showIf: (v) => v.kind === 'spot', read: (v) => v.innerAngle ?? 30 },
    { key: 'outerAngle', label: 'Outer Angle', type: num(1, { min: 0, max: 360 }), showIf: (v) => v.kind === 'spot', read: (v) => v.outerAngle ?? 90 },
    { key: 'shape', label: 'Shape', type: { kind: 'json' }, hint: 'Freeform polygon, [[x, y], ...] in entity space.', showIf: (v) => v.kind === 'freeform', read: (v) => v.shape ?? [] },
    { key: 'cookie', label: 'Cookie', type: { kind: 'string' }, showIf: (v) => v.kind === 'sprite', read: (v) => v.cookie ?? '' },
    { key: 'height', label: 'Height', type: num(0.1), hint: 'Height above the sprite plane for normal-mapped sprites.', read: (v) => v.height ?? 0.5 },
    { key: 'shadows', label: 'Shadows', type: { kind: 'bool' }, read: (v) => v.shadows ?? false },
    { key: 'shadowIntensity', label: 'Shadow Intensity', type: num(0.05, { min: 0, max: 1 }), showIf: (v) => v.shadows === true, read: (v) => v.shadowIntensity ?? 1 },
    { key: 'shadowSoftness', label: 'Shadow Softness', type: num(0.05, { min: 0 }), showIf: (v) => v.shadows === true, read: (v) => v.shadowSoftness ?? 0.2 },
    { key: 'enabled', label: 'Enabled', type: { kind: 'bool' }, read: (v) => v.enabled ?? true },
  ],
};
export default light2d;
